import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const ENDPOINT_URLS = {
  datadog: 'https://app.datadoghq.com/api/',
  datadog_eu: 'https://app.datadoghq.eu/api/',
  newrelic: 'https://api.newrelic.com/',
  pagerduty: 'https://api.pagerduty.com/',
  k6: 'https://api.k6.io/'
}

export const ADDITIONAL_KNOWN_URLS = {
  datadog: ['https://api.datadoghq.com/api/'],
  datadog_eu: ['https://api.datadoghq.eu/api/']
}

export const DOMAIN_NAME_INTEGRATIONS: IntegrationType[] = [
  IntegrationType.Grafana,
  IntegrationType.Dynatrace,
  IntegrationType.Appdynamics
]
